/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Unified ticket payload shared between the draft and send tools, and the UI component.
 * @export
 * @interface ZendeskTicketData
 */
export interface ZendeskTicketData {
    /**
     * 
     * @type {string}
     * @memberof ZendeskTicketData
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof ZendeskTicketData
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ZendeskTicketData
     */
    priorityLevel?: ZendeskTicketDataPriorityLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof ZendeskTicketData
     */
    ticketForm?: string;
    /**
     * 
     * @type {string}
     * @memberof ZendeskTicketData
     */
    product?: ZendeskTicketDataProductEnum | null;
    /**
     * 
     * @type {string}
     * @memberof ZendeskTicketData
     */
    installBaseId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ZendeskTicketData
     */
    environment?: ZendeskTicketDataEnvironmentEnum | null;
    /**
     * 
     * @type {string}
     * @memberof ZendeskTicketData
     */
    version?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ZendeskTicketData
     */
    customerCritical?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ZendeskTicketData
     */
    businessImpactDetails?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ZendeskTicketData
     */
    companyTicketId?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ZendeskTicketData
     */
    cc?: Array<string> | null;
    /**
     * Names of fields that were automatically populated by the Guardian agent.
     * @type {Array<string>}
     * @memberof ZendeskTicketData
     */
    guardianFilled?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ZendeskTicketData
     */
    pendingReview?: Array<string> | null;
}


/**
 * @export
 */
export const ZendeskTicketDataPriorityLevelEnum = {
    P1: 'p1',
    P2: 'p2',
    P3: 'p3',
    ServiceRequest: 'service_request'
} as const;
export type ZendeskTicketDataPriorityLevelEnum = typeof ZendeskTicketDataPriorityLevelEnum[keyof typeof ZendeskTicketDataPriorityLevelEnum];

/**
 * @export
 */
export const ZendeskTicketDataProductEnum = {
    ArtescaSoftware: 'ARTESCA Software',
    ArtescaHardware: 'ARTESCA Hardware',
    Artesca: 'ARTESCA +',
    Maestro: 'Maestro',
    RingIncludingS3C: 'RING (including S3C)'
} as const;
export type ZendeskTicketDataProductEnum = typeof ZendeskTicketDataProductEnum[keyof typeof ZendeskTicketDataProductEnum];

/**
 * @export
 */
export const ZendeskTicketDataEnvironmentEnum = {
    Production: 'Production',
    StagingPreProduction: 'Staging / Pre-Production',
    Development: 'Development',
    Other: 'Other'
} as const;
export type ZendeskTicketDataEnvironmentEnum = typeof ZendeskTicketDataEnvironmentEnum[keyof typeof ZendeskTicketDataEnvironmentEnum];


/**
 * Check if a given object implements the ZendeskTicketData interface.
 */
export function instanceOfZendeskTicketData(value: object): value is ZendeskTicketData {
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function ZendeskTicketDataFromJSON(json: any): ZendeskTicketData {
    return ZendeskTicketDataFromJSONTyped(json, false);
}

export function ZendeskTicketDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ZendeskTicketData {
    if (json == null) {
        return json;
    }
    return {
        
        'subject': json['subject'],
        'description': json['description'],
        'priorityLevel': json['priority_level'] == null ? undefined : json['priority_level'],
        'ticketForm': json['ticket_form'] == null ? undefined : json['ticket_form'],
        'product': json['product'] == null ? undefined : json['product'],
        'installBaseId': json['install_base_id'] == null ? undefined : json['install_base_id'],
        'environment': json['environment'] == null ? undefined : json['environment'],
        'version': json['version'] == null ? undefined : json['version'],
        'customerCritical': json['customer_critical'] == null ? undefined : json['customer_critical'],
        'businessImpactDetails': json['business_impact_details'] == null ? undefined : json['business_impact_details'],
        'companyTicketId': json['company_ticket_id'] == null ? undefined : json['company_ticket_id'],
        'cc': json['cc'] == null ? undefined : json['cc'],
        'guardianFilled': json['guardian_filled'] == null ? undefined : json['guardian_filled'],
        'pendingReview': json['pending_review'] == null ? undefined : json['pending_review'],
    };
}

export function ZendeskTicketDataToJSON(json: any): ZendeskTicketData {
    return ZendeskTicketDataToJSONTyped(json, false);
}

export function ZendeskTicketDataToJSONTyped(value?: ZendeskTicketData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subject': value['subject'],
        'description': value['description'],
        'priority_level': value['priorityLevel'],
        'ticket_form': value['ticketForm'],
        'product': value['product'],
        'install_base_id': value['installBaseId'],
        'environment': value['environment'],
        'version': value['version'],
        'customer_critical': value['customerCritical'],
        'business_impact_details': value['businessImpactDetails'],
        'company_ticket_id': value['companyTicketId'],
        'cc': value['cc'],
        'guardian_filled': value['guardianFilled'],
        'pending_review': value['pendingReview'],
    };
}

